import { render } from "./ImpiantiRead.vue?vue&type=template&id=69250710"
import script from "./ImpiantiRead.vue?vue&type=script&lang=js"
export * from "./ImpiantiRead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__